const hasExternalReferrer = (referrer = '') => referrer.indexOf(window.location.hostname) === -1;

export { hasExternalReferrer };
